import { render } from "./ModifyItem.vue?vue&type=template&id=d1b3f2ca&scoped=true"
import script from "./ModifyItem.vue?vue&type=script&lang=js"
export * from "./ModifyItem.vue?vue&type=script&lang=js"

import "./ModifyItem.vue?vue&type=style&index=0&id=d1b3f2ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1b3f2ca"]])

export default __exports__